import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import Safety from "../pages/safety/page";
import FaqPage from "../pages/faq/page";
import LangLayout from "../components/feature/LangLayout";

const routes: RouteObject[] = [
  {
    path: "/:lang",
    element: <LangLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "article/:slug", element: <Article /> },
      { path: "safety", element: <Safety /> },
      { path: "faq", element: <FaqPage /> },
    ],
  },
  {
    path: "/",
    element: <Navigate to="/en" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;